/** Small colored dot signaling workload nearing/over capacity for a day or regime block. */
import { Box } from '@mui/material';
import { getCapacityColor } from '@/utils/colorUtils';

const DOT_SIZE = 6;

const CapacityDot = ({ planned, max }) => {
  const color = getCapacityColor(planned, max);
  if (!color) return null;

  return (
    <Box
      data-testid="capacity-dot"
      sx={{
        width: DOT_SIZE,
        height: DOT_SIZE,
        borderRadius: '50%',
        bgcolor: color,
        flexShrink: 0,
      }}
    />
  );
};

export default CapacityDot;
